module.exports = __webpack_public_path__ + "media/landing_page/instacart-eightfold-lockup-70f03bc7.svg";